<div class="screen-container">

  <div class="content-area d-flex flex-column align-items-center justify-content-center px-4 flex-grow-1">

    <div class="error-icon-box mb-5">
      <i class="fas fa-wrench"></i>
    </div>

    <h1 class="error-code text-center mb-2">500</h1>
    <h2 class="error-title text-center mb-3">Something went wrong</h2>
    <p class="error-message text-center">Don't worry, we're working on it.<br>Please try again in a moment.</p>

  </div>

  <div class="praticko-footer text-center py-4">
    <h2 class="footer-brand mb-1">{{ 'common.brandName' | translate }}</h2>
    <small class="footer-sub d-block">{{ 'common.developedBy' | translate }}</small>
    <small class="footer-sub d-block">{{ 'common.versionInfo' | translate }}</small>
  </div>

</div>
